/*
 * EmailLink.jsx (AbstractUser)
 *
 * Copyright © 2022 InstaLOD GmbH - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * This file and all its contents are proprietary and confidential.
 *
 * Maintained by James Ugbanu, 2022
 *
 * @file EmailLink.jsx
 * @author James Ugbanu
 * @copyright 2022 InstaLOD GmbH. All rights reserved.
 * @section License
 */

import React from 'react';
import './IdentityCard.css';
import { copyValueHandler } from '../../../Shared/utils/sharedFunctions'

/**
 * @interface IEmailLinkProperties
 */
interface IEmailLinkProperties {
  data: {
    value: string; /** Email */
    iconStyle: string; /** Icon */
  }; /**< email and icon. */
  copyToClipboardSuccessHandler: () => void; /**< Function to trigger copy to clipboard dialog. */
}

/**
* Renders email link with copy functionality.
*/
const EmailLink = ({
  data,
  copyToClipboardSuccessHandler
}: IEmailLinkProperties) => {
  return (
    <p className="mt-2 d-flex email-link-custom-container">
      <i className={`${data.iconStyle} p-0 d-flex`}> 
        <div className="ml-1 email-link" 
          onClick={() => {
            window.location.href = `mailto:${data.value}`;
          }}>
          - {data.value}
        </div>
      </i>
      <i className="far fa-copy copy-icon" 
        onClick={() => copyValueHandler(data.value, navigator, copyToClipboardSuccessHandler)} 
      />
    </p>
  );
};

export default EmailLink;
